// Usually, media queries should be used to detect screen size when determining what css to apply
// In some cases, programmatic or device-specific behaviors need to be accounted for, and require knowing whether 
// a device is running mobile OS or desktop OS. This file provides a simple way to determine that.
enum DeviceType {
  Mobile = 'mobile',
  Desktop = 'desktop',
  // We may want to also support these device types in the future
  // Tablet = 'tablet',
  // Smartwatch = 'smartwatch',
  // Console = 'console',
  // TV = 'tv',
}
/**
 * Uses multiple methods to determine if the device is a mobile device, and returns true if any of them return true
 * @param { Object } options
 * @param { boolean } options.testUserAgent Test the `navigator.userAgent` property to see if it contains the string `mobile`
 * @param { boolean } options.testTouch Test if the `window` object has the `ontouchstart` property
 * @param { boolean } options.testMediaQuery Test if the `window` object matches the media query `(any-pointer:coarse),(pointer:none),(hover:none)`
 * @returns { boolean }
 */
function isMobileDevice({
  testUserAgent = true,
  testTouch = true,
  testMediaQuery = true,
} = { testUserAgent: true, testTouch: true, testMediaQuery: true
}): boolean {
  if (testUserAgent && /mobile/i.test(navigator.userAgent)) return true;
  if (testTouch && 'ontouchstart' in window) return true;
  const mobileMediaQuery = '(any-pointer:coarse),(pointer:none),(hover:none)';
  if (testMediaQuery && window.matchMedia && window.matchMedia(mobileMediaQuery).matches) return true;
  return false;
}
function getDeviceType(): DeviceType {
  return isMobileDevice() ? DeviceType.Mobile : DeviceType.Desktop;
}
export {
  isMobileDevice,
  getDeviceType,
  DeviceType,
}
